import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 19v-7l-5 -7","key":"svg-0"}],["path",{"d":"M17 5l-5 7","key":"svg-1"}],["path",{"d":"M8 13h8","key":"svg-2"}]]

/**
 * IconCurrencyYuan
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3kteXVhbiIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgMTl2LTdsLTUgLTciIC8+CiAgPHBhdGggZD0iTTE3IDVsLTUgNyIgLz4KICA8cGF0aCBkPSJNOCAxM2g4IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/currency-yuan
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyYuan = createReactComponent('outline', 'currency-yuan', 'CurrencyYuan', __iconNode);

export default IconCurrencyYuan;